// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"BAList--next-sr-only--1F23F6N","BAList":"BAList--BAList--31fTsRG"};